var _excluded = ["button"],
    _excluded2 = ["icon", "variant", "message", "primaryButton", "secondaryButton"];

var _templateObject;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { borders, margins, paddings } from '@gympass/yoga-system';
import { checkPropTypes, elementType, func, oneOf, shape, string } from 'prop-types';
import Box from '../../Box';
import Button from '../../Button';
import Icon from '../../Icon';
import Text from '../../Text';
var StyledBanner = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_ref) {
  var variant = _ref.variant,
      _ref$theme$yoga = _ref.theme.yoga,
      banner = _ref$theme$yoga.components.banner,
      spacing = _ref$theme$yoga.spacing,
      _ref$theme$yoga$color = _ref$theme$yoga.colors.feedback[variant],
      backgroundColor = _ref$theme$yoga$color === void 0 ? {
    light: banner.defaultBackgroundColor
  } : _ref$theme$yoga$color;
  return "\n    background-color: " + backgroundColor.light + ";\n    padding: " + spacing.xxsmall + "px\n      " + spacing.small + "px;\n    border-radius: " + banner.border.radius + "px;\n  ";
}, margins, paddings, borders);
var BannerActionButton = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var _ref2$button = _ref2.button,
      label = _ref2$button.label,
      action = _ref2$button.action,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(Box, _extends({
    as: Button.Text,
    small: true,
    secondary: true,
    onClick: action,
    ref: ref
  }, props), label);
});
BannerActionButton.propTypes = {
  button: shape({
    label: string.isRequired,
    action: func.isRequired
  }).isRequired
};
/** A banner is a component that displays a prominent message. It can have related action buttons on it or not. */

var Banner = /*#__PURE__*/forwardRef(function (props, ref) {
  var icon = props.icon,
      variant = props.variant,
      message = props.message,
      primaryButton = props.primaryButton,
      secondaryButton = props.secondaryButton,
      rest = _objectWithoutPropertiesLoose(props, _excluded2);

  return /*#__PURE__*/React.createElement(StyledBanner, _extends({
    ref: ref,
    variant: variant
  }, rest), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flex: 1,
    alignItems: "center"
  }, icon && /*#__PURE__*/React.createElement(Icon, {
    as: icon,
    size: "medium",
    fill: "secondary",
    marginRight: "xxsmall"
  }), /*#__PURE__*/React.createElement(Text.Small, {
    flex: 1,
    marginVertical: "xxsmall"
  }, message), primaryButton && !secondaryButton && /*#__PURE__*/React.createElement(BannerActionButton, {
    button: primaryButton,
    marginLeft: "xxsmall"
  })), primaryButton && secondaryButton && /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flex: 1,
    justifyContent: "flex-end",
    marginBottom: "xxsmall"
  }, /*#__PURE__*/React.createElement(BannerActionButton, {
    button: primaryButton,
    marginRight: "xxxsmall"
  }), /*#__PURE__*/React.createElement(BannerActionButton, {
    button: secondaryButton
  })));
});
var BannerActionButtonType = shape({
  label: string.isRequired,
  action: func.isRequired
});
Banner.propTypes = {
  /** SVG to be rendered. */
  icon: elementType,

  /** style the banner following the theme (success, informative, attention) */
  variant: oneOf(['success', 'informative', 'attention']),

  /** the message to display */
  message: string.isRequired,

  /** the label and action fuction are required for banner action buttons  */
  primaryButton: BannerActionButtonType,

  /** the secondary button should only be used assemble the primary button (the label and action fuction are required for banner action buttons).  */
  secondaryButton: function secondaryButton(props, propName, componentName) {
    var _checkPropTypes;

    var primaryButton = props.primaryButton;

    if (!primaryButton && !!props[propName]) {
      return new Error("The " + propName + " must only be used ensemble with the primaryButton.");
    }

    return checkPropTypes((_checkPropTypes = {}, _checkPropTypes[propName] = BannerActionButtonType, _checkPropTypes), props, 'prop', componentName);
  }
};
Banner.defaultProps = {
  icon: undefined,
  variant: 'informative',
  primaryButton: undefined,
  secondaryButton: undefined
};
export default Banner;